import Axios from "axios";
import {
  SET_BUYER_ORDER_LIST,
  UNSET_BUYER_ORDER_LIST,
} from "@/store/mutation-types";

import { buyerOrderResource } from "@/store/api";

const state = {
  getBuyerOrderList: [],
};

const getters = {
  getBuyerOrderList(state) {
    return state.getBuyerOrderList;
  },
};

const mutations = {
  [SET_BUYER_ORDER_LIST](state, data) {
    state.getBuyerOrderList = data;
  },
  [UNSET_BUYER_ORDER_LIST](state) {
    state.getBuyerOrderList = [];
  },
};

const actions = {

    getBuyerOrderList({ commit }, params = {}) {
        return new Promise((resolve, reject) => {
        Axios.get(buyerOrderResource, { params })
            .then((response) => {
            commit(SET_BUYER_ORDER_LIST, response.data.data);
            resolve(response);
            })
            .catch((error) => {
            commit(UNSET_BUYER_ORDER_LIST);
            reject(error);
            });
        });
    },

    saveBuyerOrder({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });

        return new Promise((resolve, reject) => {
        Axios.post(buyerOrderResource, data)
            .then((response) => {
            resolve(response);
            })
            .catch((error) => {
            reject(error);
            })
            .finally(() => {
            commit("UNSET_LOADING");
            });
        });
    },

    updateBuyerOrder({ commit }, { id, data }) {
        commit("SET_LOADING", { color: "primary" });

        const url = `${buyerOrderResource}/${id}`;

        return new Promise((resolve, reject) => {
        Axios.put(url, data)
            .then((response) => {
            resolve(response);
            })
            .catch((error) => {
            reject(error);
            })
            .finally(() => {
            commit("UNSET_LOADING");
            });
        });
    },

    getBuyerOrderById({ commit }, { id }) {
        commit("SET_LOADING", { color: "primary" });

        const url = `${buyerOrderResource}/${id}`;

        return new Promise((resolve, reject) => {
        Axios.get(url)
            .then((response) => {
            resolve(response);
            })
            .catch((error) => {
            reject(error);
            })
            .finally(() => {
            commit("UNSET_LOADING");
            });
        });
    },

};

export default {
  state,
  getters,
  actions,
  mutations,
};
